import React, { useEffect, useMemo, useRef, useState } from 'react'
import { CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CModal, CModalHeader, CModalBody, CModalFooter, CModalTitle, CButton, CCallout } from '@coreui/react'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import PatientInsurance from './PatientInsurance'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars'
import SchedulerAccordian from '../../components/shared/SchedulerAccordian'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { getAllAppointmentsDetails, getScheduledAppointment } from '../../components/shared/appointmentFilterData'

let cachedSchedulerInsuranceList = null
let cachedSchedulerInsurancePromise = null

const UpdateSchedulerData = ({ handleReorderSubmit, setAppointments, allAppointments, appointments, selectedDate, selectedProvider, patientData, accordionState, setAccordionState, handleSubmit, getLatestData, formatDateFilter, handleDeleteAppointment }) => {
  const allData = useRef()

  // const [accordionState, setAccordionState] = useState([]);
  const [activeTab, setActiveTab] = useState({})
  const [insuranceList, setInsuranceList] = useState([])
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState({})
  const [accordionInsuranceDetails, setAccordionInsuranceDetails] = useState({})
  const [draggedIndex, setDraggedIndex] = useState(null)
  const [filteredAppointmentsData, setFilteredAppointmentsData] = useState([])
  const [showDelete, setShowDelete] = useState(false)
  const [deleteID, setDeleteID] = useState(null)
  const formatDateString = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
  }

  const filteredAppointments = useMemo(() => {
    return (
      appointments?.filter((item) => {
        const apptDate = formatDateString(item.data?.StartTime)
        const selected = selectedDate ? formatDateString(selectedDate) : null
        const providerName = item.data?.ProviderName?.trim()
        const selectedProviderName = selectedProvider?.Name?.trim()

        if (selected && !selectedProviderName) {
          return apptDate === selected
        }

        if (selected && selectedProviderName) {
          return apptDate === selected && providerName === selectedProviderName
        }

        if (!selected && !selectedProviderName) {
          return true
        }

        return false
      }) || []
    )
  }, [appointments, selectedDate, selectedProvider])

  // Inside your map, just before return

  const getData = async () => {
    if (cachedSchedulerInsuranceList) {
      const uniqueInsuranceTypes = Array.from(new Set(cachedSchedulerInsuranceList.map((insurance) => insurance.Type)))
      setInsuranceList(cachedSchedulerInsuranceList)
      setInsuranceTypes(uniqueInsuranceTypes)
      return
    }

    if (!cachedSchedulerInsurancePromise) {
      cachedSchedulerInsurancePromise = (async () => {
        const insuranceResponse = await fetchPatientData('GET', 'Insurance', '{}')
        cachedSchedulerInsuranceList = JSON.parse(insuranceResponse.d)?.Data || []
        return cachedSchedulerInsuranceList
      })()
    }

    try {
      const insuranceData = await cachedSchedulerInsurancePromise
      const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((insurance) => insurance.Type)))
      setInsuranceList(insuranceData)
      setInsuranceTypes(uniqueInsuranceTypes)
    } finally {
      cachedSchedulerInsurancePromise = null
    }
  }

  const selectPatientFn = async (patient, accordionIndex = null) => {
    //    setSelectedPatient(patient);

    let selectedPatient = patient

    let oldAppointments = appointments.filter((item) => item.current.Patient.value === selectedPatient.value)

    let insurances = []

    if (selectedPatient) {
      let patientInsurance = await PatientInsuranceFn('SELECT', '', selectedPatient.value)
      try {
        patientInsurance = JSON.parse(patientInsurance.d)?.Data
        console.log('patientInsurance', patientInsurance)
      } catch (e) { }

      if (accordionIndex !== null) {
        setAccordionInsuranceDetails((prev) => ({
          ...prev,
          [accordionIndex]: { Insurances: patientInsurance },
        }))
      }
    }
  }

  const handleTabChange = (index, tab) => {
    setActiveTab((prev) => ({ ...prev, [index]: tab }))
  }

  useEffect(() => {
    const defaultTabs = {}
    filteredAppointments.forEach((_, index) => {
      defaultTabs[index] = 'insurance'
    })
    setActiveTab(defaultTabs)
  }, [accordionInsuranceDetails])

  useEffect(() => {
    getData()
  }, [])
  const handleDeleteData = async () => {
    try {
      const dataForDelete = appointments.filter((item) => item.data.AppointmentID === deleteID)
      const providerID = dataForDelete[0]?.current?.Provider?.value
      const selectedDateToDelete = selectedDate ? formatDateFilter(selectedDate) : dataForDelete[0]?.data?.StartTime.split(' ')[0]
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', selectedDateToDelete, providerID)
      console.log('appointemetn id', latestData)
      let appointment = latestData.filter((item) => item.data.AppointmentID !== deleteID)
      // localStorage.setItem("Appointments", JSON.stringify(appointment))
      handleDeleteAppointment(appointment, providerID, selectedDateToDelete)
      setDeleteID(null)
      setShowDelete(false)

      // await getData();
    } catch (e) {
      toast.error('An error occurred while deleting the appointment.', toastConfig)
      console.error('Error:', e)
    }
  }

  const handleDragStart = (index) => {
    setDraggedIndex(index)
  }

  const handleDrop = async (dropIndex) => {
    if (!selectedDate || !selectedProvider) {
      alert('Please select both a date and a provider to reorder the data.')
      console.log("alert('Please select both a date and a provider to reorder the data.')")
      return
    }

    if (draggedIndex === null || draggedIndex === dropIndex) return

    const updatedFiltered = [...filteredAppointments]
    const [draggedItem] = updatedFiltered.splice(draggedIndex, 1)
    updatedFiltered.splice(dropIndex, 0, draggedItem)
    setDraggedIndex(null)
    setFilteredAppointmentsData(updatedFiltered)
    const latestData = await getScheduledAppointment('GETBYSCHEDULEDATEANDPROVIDERID', formatDateFilter(selectedDate), selectedProvider?.value)
    const filteredIndexes = latestData
      .map((appt, idx) => {
        const isMatch = filteredAppointments.some((f) => f.data.AppointmentID === appt.data.AppointmentID)
        return isMatch ? idx : -1
      })
      .filter((idx) => idx !== -1)

    const newAppointmentList = [...latestData]

    filteredIndexes.forEach((originalIdx, i) => {
      newAppointmentList[originalIdx] = updatedFiltered[i]
    })

    console.log('Final reordered appointment list:', newAppointmentList)
    handleReorderSubmit(newAppointmentList, 'save')
    setAppointments(newAppointmentList)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const groupByFacility = (appointments) => {
    return appointments.reduce((acc, appt) => {
      const facilityKey = appt.current.Facility?.value || appt.current.Facility?.label
      const facilityLabel = appt.current.Facility?.label || 'Unknown Facility'

      if (!acc[facilityKey]) {
        acc[facilityKey] = {
          label: facilityLabel,
          items: [],
        }
      }

      acc[facilityKey].items.push(appt)
      return acc
    }, {})
  }

  const facilityGroups = useMemo(() => groupByFacility(filteredAppointments), [filteredAppointments])

  return (
    <div>
      {filteredAppointments?.length === 0 ? (
        <div className="text-muted text-center">No appointments found.</div>
      ) : (
        <>
          <div className="scheduler-theme__appointments">
            {Object.entries(facilityGroups).map(([facilityKey, { label, items }]) => (
              <div key={facilityKey} className="mb-2">
                <SchedulerAccordian
                  title={<strong className="scheduler-theme__accordion-title">{label}</strong>}
                  type={'facility'}
                  content={
                    <div alwaysOpen>
                      {items.map((item, index) => {
                        const { data } = item

                        const updateAccordionState = (indexInFlatList, field, value) => {
                          setAccordionState((prev) => {
                            const newState = [...prev]
                            newState[indexInFlatList] = {
                              ...newState[indexInFlatList],
                              [field]: value,
                              AppointmentID: item?.data?.AppointmentID,
                            }
                            return newState
                          })
                        }

                        const globalIndex = filteredAppointments.findIndex((a) => a.data.AppointmentID === item.data.AppointmentID)
                        const patientFilter = patientData.filter((pd) => pd.PatientID === item?.current?.Patient?.value)

                        const patientStatus = patientFilter.length > 0 ? patientFilter[0].Status : 'NewPatient'
                        console.log("Global Index:", patientStatus, patientFilter,filteredAppointments)

                        return (
                          <div key={data.AppointmentID} draggable onDragStart={() => handleDragStart(index)} onDragOver={handleDragOver} onDrop={() => handleDrop(index)}>
                            <SchedulerAccordian
                              title={
                                <div className="scheduler-appointment-title d-flex align-items-center">
                                  <div
                                    className="scheduler-appointment-name flex-shrink-0"
                                    style={{
                                      width: '150px',
                                      overflow: 'auto',
                                      whiteSpace: 'nowrap',

                                    }}
                                  >
                                    {data.AppointmentName}
                                  </div>



                                  <div
                                    className="scheduler-appointment-pills d-flex align-items-center flex-shrink-0 me-1"
                                  >
                                    <div className="room-spill scheduler-theme__pill scheduler-theme__pill--room">
                                        {data?.RoomNumber}
                                    </div>
                                       <div className="schedule1-spill scheduler-theme__pill scheduler-theme__pill--provider">{data?.ProviderName}</div>
                                    <div className="schedule-spill scheduler-theme__pill scheduler-theme__pill--date">{data?.StartTime.split(' ')[0]}</div>
                                  
                                  </div>




                                </div>

                              }
                              patientStatus={patientStatus}
                              patientData={patientData.filter((pd) => pd.PatientID === item?.current?.Patient?.value)}
                              AppointmentID={data.AppointmentID}
                              appointmentScheduleDate={data?.StartTime?.split?.(' ')?.[0]}
                              onHeaderClick={() => selectPatientFn(item?.current?.Patient, globalIndex)}
                              handleDeleteData={() => {
                                setDeleteID(data.AppointmentID), setShowDelete(true)
                              }}
                              content={
                                <div>
                                  <CNav variant="pills" className="mb-3 justify-content-center ">
                                    <CNavItem>
                                      <CNavLink active={activeTab[index] === 'insurance'} onClick={() => handleTabChange(index, 'insurance')}>
                                        Insurance Details
                                      </CNavLink>
                                    </CNavItem>
                                    <CNavItem>
                                      <CNavLink active={activeTab[index] === 'other'} onClick={() => handleTabChange(index, 'other')}>
                                        Other Details
                                      </CNavLink>
                                    </CNavItem>
                                  </CNav>

                                  <CTabContent>
                                    <CTabPane visible={activeTab[index] === 'insurance'}>
                                      <PatientInsurance
                                        allData={allData}
                                        Credentialed={'hidden'}
                                        addedInsurances={addedInsurances[index] || []}
                                        setAddedInsurances={(insurances) => setAddedInsurances((prev) => ({ ...prev, [index]: insurances }))}
                                        selectedDetails={accordionInsuranceDetails[index]}
                                        insuranceList={insuranceList}
                                        insuranceTypes={insuranceTypes}
                                        setActiveTab={setActiveTab}
                                        index={index}
                                        updateAccordionState={updateAccordionState}
                                        patientId={item?.current?.Patient?.value}
                                      />
                                    </CTabPane>

                                    <CTabPane role="tabpanel" visible={activeTab[index] === 'other'}>
                                      <div className="mx-5 mt-4 scheduler-theme__details-pane">
                                        <div className="form-check mb-3 d-flex align-items-center gap-2">
                                          <input
                                            type="checkbox"
                                            id="priorAuthCheckbox"
                                            className="form-check-input"
                                            checked={accordionState[index]?.otherDetails?.priorAuth?.isRequired || false}
                                            onChange={(e) => {
                                              updateAccordionState(index, 'otherDetails', {
                                                ...accordionState[index]?.otherDetails,
                                                priorAuth: {
                                                  ...accordionState[index]?.otherDetails?.priorAuth,
                                                  isRequired: e.target.checked,
                                                },
                                              })
                                            }}
                                          />
                                          <label htmlFor="priorAuthCheckbox" className="form-check-label mt-1">
                                            Does Need Prior Auth?
                                          </label>
                                        </div>

                                        {accordionState[index]?.otherDetails?.priorAuth?.isRequired && (
                                          <div className="scheduler-theme__details-card">
                                            <div className="mb-2">
                                              <label htmlFor="priorAuthNo" className="form-label">
                                                Prior Auth No:
                                              </label>
                                              <input
                                                type="text"
                                                id="priorAuthNo"
                                                name="priorAuthNo"
                                                className="form-control"
                                                value={accordionState[index]?.otherDetails?.priorAuth?.details?.priorAuthNo || ''}
                                                placeholder="Enter Prior Auth No"
                                                onChange={(e) => {
                                                  updateAccordionState(index, 'otherDetails', {
                                                    ...accordionState[index]?.otherDetails,
                                                    priorAuth: {
                                                      ...accordionState[index]?.otherDetails?.priorAuth,
                                                      details: {
                                                        ...accordionState[index]?.otherDetails?.priorAuth?.details,
                                                        priorAuthNo: e.target.value,
                                                      },
                                                    },
                                                  })
                                                }}
                                              />
                                            </div>

                                            <div className="mb-2">
                                              <label htmlFor={`expDate-${index}`} className="form-label">
                                                Expiration Date:
                                              </label>
                                              <DateTimePickerComponent
                                                id={`expDate-${index}`}
                                                name="expDate"
                                                format="MM/dd/yyyy"
                                                value={accordionState[index]?.otherDetails?.priorAuth?.details?.expDate ? new Date(accordionState[index].otherDetails.priorAuth.details.expDate) : null}
                                                className="form-control"
                                                change={(e) => {
                                                  const selectedDate = e?.value

                                                  updateAccordionState(index, 'otherDetails', {
                                                    ...accordionState[index]?.otherDetails,
                                                    priorAuth: {
                                                      ...accordionState[index]?.otherDetails?.priorAuth,
                                                      details: {
                                                        ...accordionState[index]?.otherDetails?.priorAuth?.details,
                                                        expDate: selectedDate?.toISOString(),
                                                      },
                                                    },
                                                  })
                                                }}
                                              />
                                            </div>

                                            <div>
                                              <label htmlFor="noOfTimes" className="form-label">
                                                No. of Times:
                                              </label>
                                              <input
                                                type="number"
                                                id="noOfTimes"
                                                name="noOfTimes"
                                                className="form-control"
                                                value={accordionState[index]?.otherDetails?.priorAuth?.details?.noOfTimes || ''}
                                                placeholder="Enter No. of Times"
                                                onChange={(e) => {
                                                  updateAccordionState(index, 'otherDetails', {
                                                    ...accordionState[index]?.otherDetails,
                                                    priorAuth: {
                                                      ...accordionState[index]?.otherDetails?.priorAuth,
                                                      details: {
                                                        ...accordionState[index]?.otherDetails?.priorAuth?.details,
                                                        noOfTimes: e.target.value,
                                                      },
                                                    },
                                                  })
                                                }}
                                              />
                                            </div>
                                          </div>
                                        )}

                                        <div className="form-check mb-3 mt-1">
                                          <input
                                            type="checkbox"
                                            id="coSignCheckbox"
                                            className="form-check-input"
                                            checked={accordionState[index]?.otherDetails?.isCoSignRequired || false}
                                            onChange={(e) => {
                                              updateAccordionState(index, 'otherDetails', {
                                                ...accordionState[index]?.otherDetails,
                                                isCoSignRequired: e.target.checked,
                                              })
                                            }}
                                          />
                                          <label htmlFor="coSignCheckbox" className="form-check-label">
                                            Co-sign Required.
                                          </label>
                                        </div>
                                      </div>
                                    </CTabPane>
                                  </CTabContent>
                                </div>
                              }
                            />
                          </div>
                        )
                      })}
                    </div>
                  }
                />
              </div>
            ))}

            <CModal
              className="dashboard-dark-modal"
              visible={showDelete}
              size="md"
              onClose={() => {
                setShowDelete(false), setDeleteID(null)
              }}
            >
              <CModalHeader className="dashboard-dark-modal-header">
                <CModalTitle>Delete Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody className="dashboard-dark-modal-body">
                <p>Are you sure you want to delete this appointment?</p>
              </CModalBody>
              <CModalFooter className="dashboard-dark-modal-footer">
                <CButton color="secondary" variant="outline" onClick={() => {
                  setShowDelete(false), setDeleteID(null)
                }}>
                  Cancel
                </CButton>
                <CButton color="danger" className="hrm-modal-danger-btn" onClick={() => handleDeleteData()}>
                  Delete
                </CButton>
              </CModalFooter>
            </CModal>
          </div>
        </>
      )}
    </div>
  )
}

export default UpdateSchedulerData
